import { useState } from "react";
import { serverNow } from "../utils/serverClock";
import { usePolling } from "./usePolling";

// Devuelve la hora actual (del servidor, ver utils/serverClock.js) y fuerza un
// re-render cada `intervalMs`, para que los textos tipo "hace 5 min" avancen
// solos sin recargar la pantalla. Con usePolling también se actualiza al
// instante al volver a primer plano: en iOS el setInterval se congelaba con
// la pantalla bloqueada y el contador se veía detenido.
export function useNow(intervalMs = 30000) {
  const [now, setNow] = useState(serverNow());
  usePolling(() => setNow(serverNow()), intervalMs);
  return now;
}
